import { render } from "./who_to_follow_panel.vue?vue&type=template&id=b4d31272"
import script from "./who_to_follow_panel.js?vue&type=script&lang=js"
export * from "./who_to_follow_panel.js?vue&type=script&lang=js"

import "./who_to_follow_panel.vue?vue&type=style&index=0&id=b4d31272&lang=scss"

import exportComponent from "M:\\Viridian Patriots\\Server\\pleroma-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__